<template>
  <section>
    <b-carousel :indicator="false">
      <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
        <section :class="`hero pb-5 sliderHeightPadding bg-${carousel.background} is-bold`">
            <div class="hero-body container">
              <div>
                <img src="@/assets/img/logoBlanco.png"
                class="fade-in logoSlider"
                > 
                <h2 class="titleBig fontNoSoBlackFine has-text-white has-text-centered scale-in-center fontPrimary fontWeightBlack">
                  Plomero y gasista matriculado
                </h2>
                <h2 class="mt-2 mb-2 is-size-2-tablet is-size-5-mobile has-text-white fontUpperCase fontWeightBlack letterSpacingShort has-text-centered fade-in">
                  Presupuesto y visita <br class="is-hidden-tablet"> sin cargo
                </h2>
                <div class="mt-5">
                  <button
                  class="is-inline-block zIndex999 button3d is-hidden-tablet width70"
                  onclick="window.location.href='tel:+542213088411'">
                    <p class="is-size-5 fontWeightBlack letterSpacingLarge fontUpperCase fontPrimary">
                      <font-awesome-icon icon="phone" class="is-size-5 iconMenu has-text-white ml-2" />  Llamanos
                    </p>
                  </button>
                </div>
              </div>
            </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Slider',
    data () {
      return {
          param: '',
          progress: true,
          progressType: 'is-primary',
          carousels: [
              {
              background: 'img1'
              },
              {
              background: 'img2'
              }
          ]
      }
    },
    created () {
      this.catchParams()
      console.log(this.$route.query)
    },
    computed: {
      ...mapState('brand', ['brand'])
    },
    methods: {
      catchParams () {
        this.param = this.$route.query
    }
  }
}
</script>

<style lang="sass">

.bg-img1
    width: 100%
    background-size: cover
    background-repeat: no-repeat
    @media (min-width: 720px)
        background-image: url("../../assets/img/slider.jpg")
    @media (max-width: 720px)
        background-image: url("../../assets/img/sliderMobil.jpg")

.bg-img2
    width: 100%
    background-size: cover
    background-repeat: no-repeat
    @media (min-width: 720px)
        background-image: url("../../assets/img/slider2.jpg")
    @media (max-width: 720px)
        background-image: url("../../assets/img/sliderMobil2.jpg")

</style>
